import { render, staticRenderFns } from "./cut.vue?vue&type=template&id=126e5831"
import script from "./cut.vue?vue&type=script&lang=js"
export * from "./cut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports